import { ApolloLink } from '@apollo/client'
import { getStoredLocaleWithFallback } from '@retailer-platform/shared-components/src/utils/intl/intl.utils'

export const LOCALE_HEADER_KEY = 'x-IPP-User-Locale'

/**
 * This ApolloLink adds the locale to the GraphQL operation headers.
 *
 * The locale is retrieved from localStorage and included as the header
 * `x-IPP-User-Locale`.
 */
export const createLocaleLink = () => {
  const locale = getStoredLocaleWithFallback()

  return new ApolloLink((operation, forward) => {
    const operationContext = operation.getContext()

    operation.setContext({
      ...operationContext,
      headers: {
        ...operationContext.headers,
        [LOCALE_HEADER_KEY]: locale.replace('-', '_'),
      },
    })

    return forward(operation)
  })
}
